function enhancePdfLinks(root = document) {
  const links = root.querySelectorAll('a[href]');

  links.forEach((link) => {
    // Prevent processing twice
    if (link.dataset.pdfEnhanced) return;

    const href = link.getAttribute('href');
    if (!href) return;

    if (!isPdfLink(href)) return;

    link.dataset.pdfEnhanced = 'true';

    // Keep original link text
    // Example:
    // "Product Manual" stays "Product Manual"

    // Best-effort download hint
    link.setAttribute('download', 'pdf-download-file');

    // Optional
    link.setAttribute('rel', 'noopener');
    link.setAttribute('target', '_blank');

    // Apply Dawn button styling
    link.classList.add(
      'button',
      'button--secondary'
    );
  });
}

function isPdfLink(href) {
  try {
    const url = new URL(href, window.location.origin);
    return url.pathname.toLowerCase().endsWith('.pdf');
  } catch (e) {
    return false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  enhancePdfLinks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          enhancePdfLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});